import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useGroup, useUpdateGroup } from "../hooks";
import { GroupForm } from "../components";

type IUpdateGroup = {
  id: string;
};

export const UpdateGroup: React.FC = () => {
  const { id } = useParams<IUpdateGroup>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useGroup(+id!);
  const { form, submit, loading } = useUpdateGroup({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le groupe a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.group?.ok && data?.group?.result) {
      const { result } = data.group;
      form.setValue("name", result.name);
      form.setValue("siren", result.siren);
      form.setValue("notes", result.notes);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Groupe"
        subtitle={data?.group?.result?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/group/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un groupe" />
          <GroupForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
